import React from 'react';
import { ChevronRight, Shield } from 'lucide-react';
import { STATUS_CONFIG } from './constants';

export const UserRow = ({ user, onSelect }) => {
  const statusConfig = STATUS_CONFIG[user.status] || STATUS_CONFIG.activo;
  const StatusIcon = statusConfig.icon;
  
  return (
    <div 
      onClick={() => onSelect(user)}
      className={`flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-lg hover:bg-white/10 cursor-pointer transition-colors min-h-[72px] active:scale-[0.99] ${
        user.status === 'eliminado' ? 'bg-red-500/5 opacity-60' : 'bg-white/5'
      }`}
      data-testid={`user-row-${user.id}`}
    >
      {/* Usuario Info */}
      <div className="flex items-center gap-3 sm:gap-4 min-w-0">
        <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
          user.status === 'eliminado' ? 'bg-red-500/20' : 'bg-primary/20'
        }`}>
          <span className={`font-bold text-sm sm:text-base ${user.status === 'eliminado' ? 'text-red-400' : 'text-primary'}`}>
            {user.name?.charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <p className="font-semibold text-sm sm:text-base truncate">{user.name}</p>
            <span className={`px-2 py-0.5 rounded text-xs whitespace-nowrap ${statusConfig.color}`}>
              {statusConfig.label}
            </span>
            {user.is_admin && <Shield className="h-4 w-4 text-yellow-500 flex-shrink-0" />}
          </div>
          <p className="text-xs sm:text-sm text-muted-foreground truncate">{user.email}</p>
        </div>
      </div>

      {/* Plan y Créditos */}
      <div className="flex items-center justify-between sm:justify-end gap-4 mt-3 sm:mt-0 pl-[52px] sm:pl-0">
        <div className="text-left sm:text-right">
          <span className={`px-2 py-1 rounded text-xs whitespace-nowrap ${
            user.plan === 'socio' ? 'bg-purple-500/20 text-purple-300' :
            user.plan === 'inicial' ? 'bg-blue-500/20 text-blue-300' :
            user.plan === 'basic' ? 'bg-green-500/20 text-green-300' :
            'bg-gray-500/20 text-gray-300'
          }`}>
            {user.plan === 'none' ? 'Sin Plan' : user.plan.charAt(0).toUpperCase() + user.plan.slice(1)}
          </span>
          <p className="text-xs text-muted-foreground mt-1">
            {user.credits} créditos
          </p>
        </div>
        <ChevronRight className="h-5 w-5 text-muted-foreground flex-shrink-0 hidden sm:block" />
      </div>
    </div>
  );
};
